import { resolveImageUrl } from '../../components/ndoe';

// Composition des photos du Catalogue de partage (M5bis).
// Photo CARRÉE 1080×1080 INTACTE + bande BLANCHE AJOUTÉE EN DESSOUS (la toile est
// agrandie en hauteur : photo 1080 + bande hBande) portant, au choix : référence,
// prix, pointures disponibles. La bande ne recouvre JAMAIS la photo (demande proprio
// 12/07 : « photo 10×10 + bandeau 10×2 = image 10×12 »). Composition sur l'appareil.
//
// CORS : l'API sert /uploads derrière app.use(cors()) → crossOrigin='anonymous'
// garde le canvas exportable (toBlob), y compris depuis l'APK (capacitor://).

const TAILLE = 1080;

const chargerImage = (src) => new Promise((resolve, reject) => {
  const img = new Image();
  img.crossOrigin = 'anonymous';
  img.onload = () => resolve(img);
  img.onerror = () => reject(new Error('Image introuvable'));
  img.src = resolveImageUrl(src);
});

// Lignes à imprimer selon les préférences — dans l'ordre visuel :
// référence (petit, doré) / prix (gros, gras) / pointures (moyen).
function lignesPour(modele, infos) {
  const lignes = [];
  if (infos.ref && (modele.code_produit || modele.code_article)) {
    lignes.push({ texte: modele.code_produit || modele.code_article, police: '600 40px Consolas, monospace', couleur: '#8a5a10', hauteur: 62 });
  }
  if (infos.prix && modele.prixTexte) {
    lignes.push({ texte: modele.prixTexte, police: '700 64px Georgia, serif', couleur: '#071c3d', hauteur: 88 });
  }
  if (infos.pointures && modele.tailles.length) {
    lignes.push({ texte: `P${modele.tailles.join(' · ')}`, police: '500 46px Arial, sans-serif', couleur: '#233a5c', hauteur: 68 });
  }
  return lignes;
}

// Compose UNE photo. Renvoie { blob, dataUrl, fileName }.
export async function composerPhoto(modele, infos) {
  const img = await chargerImage(modele.img);

  const lignes = lignesPour(modele, infos);
  const padBande = lignes.length ? 36 : 0;
  const hBande = lignes.reduce((s, l) => s + l.hauteur, 0) + (lignes.length ? padBande * 2 : 0);

  const canvas = document.createElement('canvas');
  canvas.width = TAILLE;
  // Toile AGRANDIE : photo carrée (1080) + bande ajoutée EN DESSOUS (hBande).
  canvas.height = TAILLE + hBande;
  const ctx = canvas.getContext('2d');

  // Photo ENTIÈRE tenue dans le carré (« contain »), centrée, sur fond ivoire —
  // AUCUN recadrage : une photo non carrée garde tout son contenu, avec de fines
  // marges crème (couleur de la charte) sur les côtés ou en haut/bas.
  //
  // Avant (option validée le 18/07), le mode était « cover » (Math.min → Math.max) :
  // la photo REMPLISSAIT le carré et le débordement était rogné. Sur une photo de
  // chaussure verticale, cela coupait le haut et le bas — le proprio le voyait
  // comme « la bande mange le bas de la photo », alors que c'était le recadrage
  // carré. Le commentaire d'origine promettait déjà le fond ivoire « si l'image
  // est étroite » : le code fait enfin ce que disait ce commentaire.
  ctx.fillStyle = '#f6f1e7';
  ctx.fillRect(0, 0, TAILLE, TAILLE);
  const ratio = Math.min(TAILLE / img.width, TAILLE / img.height);
  const w = img.width * ratio;
  const h = img.height * ratio;
  ctx.drawImage(img, (TAILLE - w) / 2, (TAILLE - h) / 2, w, h);

  if (lignes.length) {
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, TAILLE, TAILLE, hBande);
    // Filet doré discret entre photo et bande.
    ctx.fillStyle = '#c28a27';
    ctx.fillRect(0, TAILLE, TAILLE, 6);

    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    let y = TAILLE + padBande;
    lignes.forEach((l) => {
      ctx.font = l.police;
      ctx.fillStyle = l.couleur;
      ctx.fillText(l.texte, TAILLE / 2, y + l.hauteur / 2, TAILLE - 80);
      y += l.hauteur;
    });
  }

  const blob = await new Promise((resolve, reject) => {
    canvas.toBlob((b) => (b ? resolve(b) : reject(new Error('Composition impossible'))), 'image/jpeg', 0.88);
  });
  const dataUrl = canvas.toDataURL('image/jpeg', 0.7);   // aperçu léger
  const base = (modele.code_produit || modele.code_article || 'article').replace(/[^\w-]/g, '');
  const fileName = `ndoe-${base}${modele.couleur ? '-' + String(modele.couleur).replace(/[^\w-]/g, '') : ''}.jpg`;
  return { blob, dataUrl, fileName };
}

// Compose la sélection complète, en tolérant les images cassées (best-effort :
// l'appelant affiche les échecs, le partage part avec ce qui a réussi).
export async function composerSelection(modeles, infos, onProgress) {
  const ok = [];
  const echecs = [];
  for (let i = 0; i < modeles.length; i += 1) {
    try {
      ok.push(await composerPhoto(modeles[i], infos));
    } catch (e) {
      echecs.push(modeles[i]);
    }
    if (onProgress) onProgress(i + 1, modeles.length);
  }
  return { ok, echecs };
}
